import React from 'react';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { StickyFooter } from '../../../CommonComponents/OPL/StickyFooter/StickyFooter';

interface Props {
  onPrevious?(): void;
  progress: number;
  showProgress?: boolean;
  isFirstStep?: boolean;
  showPrevious?: boolean;
}

export const Footer: React.FC<Props> = ({
  onPrevious,
  progress,
  showProgress = true,
  showPrevious = true,
  isFirstStep,
}) => {
  return (
    <StickyFooter progress={showProgress ? progress : undefined}>
      {showPrevious && (
        <Button
          onClick={() => onPrevious?.()}
          variant="secondary"
          leftIcon={isFirstStep ? undefined : 'fas fa-chevron-left'}
          size="large"
        >
          {isFirstStep ? 'Cancel' : 'Previous'}
        </Button>
      )}

      <Button type="submit" rightIcon="fas fa-chevron-right" size="large" ml="auto">
        Next
      </Button>
    </StickyFooter>
  );
};
